import { boot } from 'quasar/wrappers'
import VueDebounce from 'vue-debounce'

export default boot(({ app }) => {
  app.use(VueDebounce)
})
